import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  background: white;
  padding: 48px;
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 48px;
  line-height: 1.3;
  font-size: 16px;
  position: relative;

  .logo {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 120px;
  }
`;

export const FormWrapper = styled('div')`
  padding: 48px 48px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 50%;

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    width: 100%;
    align-items: center;
    padding: 48px 20px 0;
  }

  .content {
    > * {
      max-width: 500px;
      width: 100% !important;
      color: ${theme.palette.text.dark};
    }
  }

  p {
    margin-bottom: 20px;
    margin-top: 8px;
  }

  a {
    color: ${theme.palette.primary.main};
    font-weight: 700;
  }

  .forgotPassword {
    text-align: center;
    margin: 30px 0;
  }
`;

export const Description = styled('div')`
  padding: 48px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 50%;
  background: ${theme.palette.primary.main};
  border-radius: 10px;
  color: ${theme.palette.text.contrast};

  img {
    width: 100%;
    margin-top: 30px;
  }

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    display: none;
  }
`;

export const Title = styled('div')`
  font-weight: 700;
  font-size: 36px;
  line-height: normal;
  margin-bottom: 20px;
  color: ${theme.palette.text.contrast};
`;

export const Copyright = styled('div')`
  width: 100%;
  margin-top: 20px;
  font-size: 14px;
  line-height: 125%;
  color: ${theme.palette.secondary.main};
  text-align: center;
  justify-self: flex-end;
`;
